import base from "./baseService";

const conceptsUrl = "/concepts";


export default {
  getConcepts(search, type, client, industry, year, orderby, page, pageSize) {
    let params = new URLSearchParams();
    if (search) {
      params.append("search", search);
    }
    if (type) {
      params.append("type", type);
    }
    if (client) {
      params.append("client", client);
    }
    if (industry) {
      params.append("industry", industry);
    }
    if (year) {
      params.append("year", year);
    }
    if (orderby) {
      params.append("orderby", orderby);
    }
    if (page) {
      params.append("page", page);
    }
    if (pageSize) {
      params.append("pageSize", pageSize);
    }
    
    let getConceptsUrl = conceptsUrl;
    if (params.size > 0) {
      getConceptsUrl = `${conceptsUrl}?${params.toString()}`;
    }

    return new Promise((resolve, reject) => {
      base
        .get(getConceptsUrl)
        // get data
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getConcept(id) {
    const getConceptUrl = `${conceptsUrl}/${id}`;
    return new Promise((resolve, reject) => {
      base
        .get(getConceptUrl)
        // get data
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getClientsFilter() {
    const getUrl = `${conceptsUrl}/client`;
    return new Promise((resolve, reject) => {
      base
        .get(getUrl)
        // get data
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getIndustriesFilter() {
    const getUrl = `${conceptsUrl}/industry`;
    return new Promise((resolve, reject) => {
      base
        .get(getUrl)
        // get data
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getTypesFilter() {
    const getUrl = `${conceptsUrl}/type`;
    return new Promise((resolve, reject) => {
      base
        .get(getUrl)
        // get data
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getYearsFilter() {
    const getUrl = `${conceptsUrl}/projectDate`;
    return new Promise((resolve, reject) => {
      base
        .get(getUrl)
        // get data
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
